import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  onTickReady: false
};

const onTickReadySlice = createSlice({
  name: 'onTick',
  initialState,
  reducers: {
    setOnTickReady(state, action) {
      state.onTickReady = action.payload;
    }
  }
});

export const { setOnTickReady } = onTickReadySlice.actions;

const onTickReadyReducer = onTickReadySlice.reducer;
export default onTickReadyReducer;
